import { TILE_LIBRARY_TYPES } from '../../../state/map/tiles/constants';
import RoRContainer from './RoRContainer';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [TILE_LIBRARY_TYPES.LEAFLET]: RoRContainer,
  [TILE_LIBRARY_TYPES.JSLA]: RoRContainer,
};
